import { render, staticRenderFns } from "./ParticipantsAdmitted.vue?vue&type=template&id=6fa0b4f7&scoped=true&"
import script from "./ParticipantsAdmitted.vue?vue&type=script&lang=js&"
export * from "./ParticipantsAdmitted.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantsAdmitted.vue?vue&type=style&index=0&id=6fa0b4f7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa0b4f7",
  null
  
)

export default component.exports